import React, { forwardRef } from "react";
import { search_icon } from "../../../assets";
import { useTranslation } from "react-i18next";

const ShortCodeSearchBar = forwardRef(
  ({ value, onSearch, placeholder, onKeyDown, onClear }, ref) => {
    const { i18n } = useTranslation();
    const isRTL = i18n.language === "ar";

    return (
      <div className="relative w-full flex items-center">

        {/* Search Icon */}
        <span
          className="absolute inset-y-0 flex items-center"
          style={{ [isRTL ? "right" : "left"]: 8 }}
        >
          <img src={search_icon} alt="search_icon" />
        </span>

        {/* Input */}
        <input
          ref={ref}
          value={value}
          onChange={(e) => {
            let val = e.target.value;

            // Allow ONLY digits
            val = val.replace(/[^0-9]/g, "");

            // Max 12 digits
            if (val.length > 10) val = val.slice(0, 10);

            onSearch(val); // <-- Pass cleaned value to parent
          }}
          placeholder={placeholder}
          onKeyDown={onKeyDown}
          className="w-full h-10 border rounded-md px-2"
          style={{
            [isRTL ? "paddingRight" : "paddingLeft"]: "35px",
          outline: "none",

          }}
        />

        {/* Clear Button */}
        {value && (
          <button
            type="button"
            onClick={onClear}
            className="absolute right-2 text-gray-500 hover:text-black text-sm"
          >
            ✖
          </button>
        )}
      </div>
    );
  }
);

export default ShortCodeSearchBar;
